"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var http_type_1 = require("./http-type");

exports.httpCreators = {
  request: function request(params) {
    return {
      type: http_type_1.HTTP_ACTION_TYPE.REQUEST,
      payload: params
    };
  },
  cancel: function cancel(id) {
    return {
      type: http_type_1.HTTP_ACTION_TYPE.CANCEL,
      payload: id
    };
  },
  setLoading: function setLoading(id, result) {
    return {
      type: http_type_1.HTTP_ACTION_TYPE.SET_LOADING,
      payload: {
        id: id,
        result: result
      }
    };
  },
  setFailed: function setFailed(id, result) {
    return {
      type: http_type_1.HTTP_ACTION_TYPE.SET_FAILED,
      payload: {
        id: id,
        result: result
      }
    };
  }
};